import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=73117da2&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=73117da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73117da2",
  null
  
)

export default component.exports